"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _material = require("@mui/material");

var _Typography = require("../Typography");

var _Icon = require("../Icon");

var _utilities = require("../../utilities");

var _AccordionProvider = _interopRequireWildcard(require("./AccordionProvider"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["children", "expanded", "initialValues"],
    _excluded2 = ["contractLabel", "expandLabel", "summary", "onExpand"],
    _excluded3 = ["children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledMuiAccordion = (0, _material.styled)(_material.Accordion)(function (_ref) {
  var theme = _ref.theme;
  return (0, _defineProperty2.default)({}, "&.".concat(_utilities.classes.components.MuiAccordion.root), {
    "&:last-child": {
      borderBottom: "1px solid"
    },
    border: "0",
    borderColor: theme.palette.divider + " !important",
    borderTop: "1px solid",
    boxShadow: "none"
  });
});
var StyledMuiAccordionSummary = (0, _material.styled)(_material.AccordionSummary)(function (_ref3) {
  var _$concat, _ref4;

  var theme = _ref3.theme;
  return _ref4 = {}, (0, _defineProperty2.default)(_ref4, "&.".concat(_utilities.classes.components.MuiAccordionSummary.root), (_$concat = {}, (0, _defineProperty2.default)(_$concat, "& .".concat(_utilities.classes.components.MuiAccordionSummary.expanded), {
    margin: theme.spacing(0)
  }), (0, _defineProperty2.default)(_$concat, "&:hover, &:focus", {
    backgroundColor: theme.palette.common.white,
    border: "2px solid ".concat(theme.palette.focusRing.main),
    borderRadius: "3px",
    // theme.palette.focusRing.main with 50% opacity
    boxShadow: "0 2px 4px rgba(93, 176, 255,0.5)"
  }), (0, _defineProperty2.default)(_$concat, "border", "2px solid ".concat(theme.palette.common.white)), (0, _defineProperty2.default)(_$concat, "minHeight", "3rem !important"), (0, _defineProperty2.default)(_$concat, "padding", "0 0.5rem 0 0"), _$concat)), (0, _defineProperty2.default)(_ref4, "&.".concat(_utilities.classes.components.MuiAccordionSummary.content), {
    margin: "0.75rem 0 !important"
  }), (0, _defineProperty2.default)(_ref4, "& .".concat(_utilities.classes.components.MuiAccordionSummary.expandIconWrapper), {
    transform: "none !important"
  }), _ref4;
});
var StyledMuiAccordionDetails = (0, _material.styled)(_material.AccordionDetails)(function () {
  return (0, _defineProperty2.default)({}, "&.".concat(_utilities.classes.components.MuiAccordionDetails.root), {
    marginBottom: "0.75rem",
    marginRight: "0.5rem",
    padding: "0 2px"
  });
});

var Accordion = function Accordion(_ref6) {
  var _ref7;

  var children = _ref6.children,
      expanded = _ref6.expanded,
      initialValues = _ref6.initialValues,
      rest = (0, _objectWithoutProperties2.default)(_ref6, _excluded);

  var _useState = (0, _react.useState)((_ref7 = expanded !== null && expanded !== void 0 ? expanded : initialValues === null || initialValues === void 0 ? void 0 : initialValues.expanded) !== null && _ref7 !== void 0 ? _ref7 : false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      expandedState = _useState2[0],
      setExpandedState = _useState2[1];

  var isControlled = typeof expanded === "boolean";
  var isExpanded = expanded !== null && expanded !== void 0 ? expanded : expandedState;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AccordionProvider.default, {
    expanded: isExpanded,
    isControlled: isControlled,
    setExpandedState: setExpandedState,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledMuiAccordion, _objectSpread(_objectSpread({
      "data-testid": "accordion-wrapper",
      expanded: isExpanded,
      square: true
    }, rest), {}, {
      children: children
    }))
  });
};

var AccordionSummary = function AccordionSummary(_ref8) {
  var contractLabel = _ref8.contractLabel,
      expandLabel = _ref8.expandLabel,
      summary = _ref8.summary,
      _onExpand = _ref8.onExpand,
      rest = (0, _objectWithoutProperties2.default)(_ref8, _excluded2);
  var ctx = (0, _react.useContext)(_AccordionProvider.AccordionContext);

  if (!ctx) {
    throw new Error("<Accordion.AccordionSummary /> must be used within <Accordion />");
  }

  var expanded = ctx.expanded,
      isControlled = ctx.isControlled,
      setExpandedState = ctx.setExpandedState;
  var onExpand = (0, _react.useCallback)(function (state) {
    if (_onExpand) _onExpand(state);
    if (!isControlled) setExpandedState(state);
  }, [_onExpand, isControlled, setExpandedState]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledMuiAccordionSummary, _objectSpread(_objectSpread({
    "aria-label": expanded ? contractLabel : expandLabel,
    expandIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      iconName: expanded ? "minus" : "plus",
      iconStyle: "fas",
      size: "small"
    }),
    onClick: function onClick() {
      return onExpand(!expanded);
    }
  }, rest), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.Typography, {
      sx: {
        fontSize: "0.875rem",
        fontWeight: "bold"
      },
      children: summary
    })
  }));
};

var AccordionDetails = function AccordionDetails(_ref9) {
  var children = _ref9.children,
      rest = (0, _objectWithoutProperties2.default)(_ref9, _excluded3);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledMuiAccordionDetails, _objectSpread(_objectSpread({}, rest), {}, {
    children: children
  }));
};

Accordion.Summary = AccordionSummary;
Accordion.Details = AccordionDetails;
var _default = Accordion;
exports.default = _default;